import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as OfflinePluginRuntime from 'offline-plugin/runtime';

OfflinePluginRuntime.install({
  onUpdateReady: () => {
    OfflinePluginRuntime.applyUpdate();
  },
  onUpdated: () => {
    window.location.reload();
  }
});

const o: any = document;
const a = o.getElementsByTagName('head')[0];
const body = o.getElementsByTagName('body')[0];

// Load Google Tag Manager 
const gtm = o.createElement('script');
gtm.defer = true
gtm.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=${environment.googleTagManagerAuth}&gtm_preview=${environment.googleTagManagerPreview}&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${environment.googleTagManagerId}');`
a.insertBefore(gtm, a.firstChild);

const gtmNoscript = o.createElement('noscript');
const gtmIframe = o.createElement('iframe');
gtmIframe.setAttribute('src', `https://www.googletagmanager.com/ns.html?id=${environment.googleTagManagerId}&gtm_auth=${environment.googleTagManagerAuth}&gtm_preview=${environment.googleTagManagerPreview}&gtm_cookies_win=x`);
gtmIframe.setAttribute('height', '0');
gtmIframe.setAttribute('width', '0');
gtmIframe.setAttribute('style', 'display:none;visibility:hidden');
gtmNoscript.appendChild(gtmIframe)
body.insertBefore(gtmNoscript, body.firstChild);

// Load reCAPTCHA
const reCaptcha = o.createElement('script');
reCaptcha.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${environment.reCaptchaSiteKey}`);
reCaptcha.setAttribute('type', 'text/javascript');
a.appendChild(reCaptcha);

if (environment.production) {
  const onetrust = o.createElement('script');
  onetrust.setAttribute('src', 'https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js');
  onetrust.setAttribute('type', 'text/javascript');
  onetrust.setAttribute('charset', 'UTF-8');
  onetrust.setAttribute('data-domain-script', environment.onetrustDataDomainScript);
  a.appendChild(onetrust);
  // Run
  const oneTrustFct = o.createElement('script');
  oneTrustFct.setAttribute('type', 'text/javascript');
  oneTrustFct.innerText = 'function OptanonWrapper() {}';
  a.appendChild(oneTrustFct);

  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/main.ts